// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38pt4","label":"styles_label__1HsCE"};